<template>
  <div style="display: inline-block">
    <div @click="handleShowDialog">
      <slot></slot>
    </div>
    <!-- 市场顾问 -->
    <el-dialog
      destroy-on-close
      :visible.sync="dialogVisible"
      title="市场顾问列表"
      width="1000px"
      class="market-dialog"
      @close="handleCloseDialog"
    >
      <el-form>
        <el-form-item label="市场顾问:" prop="title" class="market-staff">
          <el-select
            v-model="searchInfo.staff_id"
            placeholder="请输入市场顾问姓名或手机号"
            clearable
            filterable
            :filter-method="handleSearchMarketStaff"
            @change="handleSearch"
          >
            <el-option
              v-for="item in market_staff_list"
              :key="item.staff_id"
              :label="item.name"
              :value="item.staff_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <el-table
        size="mini"
        :data="tableData"
        stripe
        ref="tableRef"
        style="width: 100%"
        tooltip-effect="dark"
        class="table"
      >
        <el-table-column width="42" align="center">
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.checked"
              @change="handleTeacherSelect(scope.row)"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="序号" type="index" width="50">
        </el-table-column>
        <el-table-column label="市场顾问 ID" prop="staff_id" width="90">
        </el-table-column>
        <el-table-column label="市场顾问姓名" prop="name"> </el-table-column>
        <el-table-column label="市场顾问手机号" prop="mobile" width="110">
        </el-table-column>
        <el-table-column label="推广活动数量" prop="activity_num" width="100">
        </el-table-column>
        <el-table-column
          label="进行中推广活动数量"
          prop="ongoing_activity_num"
          width="130"
        >
        </el-table-column>
        <el-table-column label="推广名单数" prop="roster_num" width="80">
        </el-table-column>
        <el-table-column
          label="今日推广名单数"
          prop="today_roster_num"
          width="110"
        >
        </el-table-column>
        <el-table-column label="创建时间" prop="create_time"> </el-table-column>
      </el-table>

      <el-pagination
        :current-page="page"
        :page-size="pageSize"
        :page-sizes="pageSizeArray"
        :total="total"
        class="flex pagination"
        @current-change="handlePagerChange"
        @size-change="handlePagerSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>

      <div class="flex">
        <el-button class="mwow-button-filled success" @click="confirmSubmit">{{
          originData.length === 0 ? "添加" : "再次添加"
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMarketStaffListApi } from "@/api/marketActivity";
import { staffList } from "@/api/globalSearch";
import { dateFormat } from "@/utils/timeFormat";

export default {
  // @Prop() originData: any;
  props: ["originData"],
  data() {
    return {
      dialogVisible: false,
      searchInfo: {
        staff_id: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      selectItem: [],
      market_staff_list: [],
      selectedList: [],
      selectedObject: [],
      timer: "",
    };
  },
  // @Watch("dialogVisible")
  // onChangeValue(n: any) {
  //   if (n) {
  //     this.getList();
  //     this.getMarketStaffListApiFn();
  //   }
  // }
  watch: {
    dialogVisible: {
      handler(n) {
        if (n) {
          this.getList();
          this.getMarketStaffListApiFn();
        }
      },
    },
  },
  methods: {
    handleShowDialog() {
      this.dialogVisible = true;
      this.selectedList = this.originData;
      const obj = {};
      this.originData.map((item) => {
        obj[item.staff_id] = item;
      });
      this.selectedObject = obj;
    },
    handleCloseDialog() {
      this.pageSize = 10;
    },
    solveSearchInfo(option) {
      let params = { ...option };
      if (this.searchInfo.staff_id) {
        params.market_staff_id = this.searchInfo.staff_id;
      }
      params.status = 1;
      return params;
    },
    getList(params) {
      let option = this.solveSearchInfo(params);
      getMarketStaffListApi(option).then((res) => {
        if (res.error_code === 0) {
          res.data.list.forEach((item) => {
            if (this.selectedObject[item.staff_id]) {
              item.checked = true;
            } else {
              item.checked = false;
            }
            item.create_time = dateFormat(
              "YYYY-mm-dd HH:MM",
              new Date(item.create_time * 1000)
            );
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    // 获取市场顾问列表
    getMarketStaffListApiFn(v) {
      staffList({
        page: 1,
        page_size: 100,
        key_word: v,
        status: 1,
        job_ids: [4],
      }).then((res) => {
        if (res.error_code === 0) {
          this.market_staff_list = res.data.list;
        }
      });
    },
    // 模糊搜索 - 市场顾问
    handleSearchMarketStaff(v) {
      this.debounce(this.getMarketStaffListApiFn, v, 500);
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    // 处理多选框选中与否
    handleTeacherSelect(row) {
      const copy = { ...this.selectedObject };
      if (copy[row.staff_id]) {
        delete copy[row.staff_id];
      } else {
        copy[row.staff_id] = row;
      }
      this.selectedObject = copy;

      const items = [];
      for (const key in copy) {
        items.unshift(copy[key]);
      }
      this.selectedList = items;

      const index = this.tableData.findIndex((item) => {
        return item.staff_id === row.staff_id;
      });

      if (index >= 0) {
        this.tableData[index].checked = !!copy[row.staff_id];
      }
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    confirmSubmit() {
      let ids = [];
      this.selectedList.map((item) => {
        ids.push(Number(item.staff_id));
      });
      this.dialogVisible = false;
      this.searchInfo.staff_id = "";
      this.$emit("change", this.selectedList);
    },
    debounce(fn, data, delay) {
      // 设置一个触发开关
      let _t = this;
      clearTimeout(_t.timer);
      _t.timer = setTimeout(() => {
        fn(data);
      }, delay);
    },
  },
};
</script>

<style scoped lang="scss">
.market-dialog {
  .el-form {
    display: flex;
    .el-form-item {
      margin-right: 20px;
      display: flex;
      .el-form-item__label {
        min-width: 100px !important;
      }
      .el-form-item__content {
        width: 74%;
        div:nth-child(1) {
          width: 100%;
        }
      }
    }
    /deep/.market-staff {
      .el-select {
        .el-input__inner {
          width: 210px;
        }
      }
    }
  }
}
.flex {
  display: flex;
  justify-content: center;
}
.pagination {
  justify-content: flex-end;
}
</style>
